import { useTheme } from '@/shared/providers/theme';
import { ClinicInformation } from '@/types/admin-clinic-detail';
import { formatPeriodDisplay } from '@/utils/dateConverter';
import { type TableProps } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { AppButton } from '@components/atoms';
import { EditFill, Plus } from '@components/atoms/AppIcon';
import AppTable from '@components/atoms/AppTable';
interface ClinicInfoTableProps {
  data: ClinicInformation[];
  clinicId: string;
}

const ClinicInfoTable = ({ data, clinicId }: ClinicInfoTableProps) => {
  const navigate = useNavigate();
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const { colors } = useTheme();

  const columns: TableProps<ClinicInformation>['columns'] = [
    {
      title: '枝番',
      dataIndex: 'order',
      key: 'order',
      width: '10%',
      render: (_, _record, index) => <p>{index + 1}</p>,
    },
    {
      title: '治療院',
      dataIndex: 'name',
      key: 'name',
      width: '200px',
    },
    {
      title: '有効期限',
      dataIndex: 'date',
      key: 'date',
      render: (_, record) => (
        <p>{formatPeriodDisplay(record.available_from, record.available_to)}</p>
      ),
      width: '150px',
    },
    {
      title: '操作',
      key: 'action',
      width: '70px',
      render: (_, record) => (
        <div className="flex gap-2">
          <AppButton
            icon={<EditFill />}
            type="primary"
            onClick={() => handleNavigateEdit(record.id)}
          >
            編集
          </AppButton>
          <AppButton
            icon={<EditFill />}
            type="primary"
            style={
              {
                backgroundColor: colors.secondary,
                ['--action-bg-hover' as string]: colors.secondaryHover,
              } as React.CSSProperties
            }
            className="hover:!bg-[var(--action-bg-hover)]"
            onClick={() => handleNavigateCopy(record.id)}
          >
            複製
          </AppButton>
        </div>
      ),
    },
  ];

  const handleNavigate = () => {
    navigate({
      pathname: `/${currentSite}/admin/clinic_informations/create`,
      search: `?clinic_id=${clinicId}`,
    });
  };

  const handleNavigateEdit = (id: number) => {
    navigate(`/${currentSite}/admin/clinic_informations/${id}/edit`);
  };

  const handleNavigateCopy = (id: number) => {
    navigate(`/${currentSite}/admin/clinic_informations/${id}/copy`);
  };

  return (
    <section>
      <div className="flex items-center gap-10 mb-4">
        <h3 className="text-xl">治療院情報</h3>
        <AppButton icon={<Plus />} type="primary" onClick={handleNavigate}>
          新規
        </AppButton>
      </div>
      <AppTable isAdminSite columns={columns} dataSource={data} rowKey={record => record.id} />
    </section>
  );
};

export default ClinicInfoTable;
